import '../../../webpack/node_modules/jquery-ui-dist/jquery-ui.min';
import '../../../webpack/node_modules/popper.js/dist/popper.min';
import '../../../webpack/node_modules/bootstrap/dist/js/bootstrap.min';
import selectBoxIt from '../../../webpack/node_modules/selectboxit/src/javascripts/jquery.selectBoxIt';
import * as lottie from '../../../webpack/node_modules/lottie-web/build/player/lottie';
import axios from '../../../webpack/node_modules/axios/dist/axios.min';

console.log('javascript loaded');

var _bookmarks = [];
var lastRepId = "";
var lastClientNote = "";
var bookmarkId = "";
var submitUrl = 'https://suns.vipfanportal.com/bookmarks/0/submitBookmarks.php';

$(document).ready(function() {
    console.log('jQuery ready');
    setTimeout(function() {
        $("#landing").fadeIn(1000);
        var animation = lottie.loadAnimation({
            container: document.getElementById('animation'),
            renderer: 'svg',
            loop: false,
            autoplay: true,
            path: 'animation/project201.json',
            complete: setTimeout(function() {
                $("body").removeClass('loading');
            }, 1500)
        })
    }, 1000);
    setTimeout(function() {

        // $("body").removeClass('initial');
    }, 1500);
    navigation();
    beforeAfter();
    suites();
    replaceImgWithSVG();
    initBookmarks();

    $("select").selectBoxIt({
        showFirstOption: false
    });
});

// full screen intro video
$(function() {
    $(document).ready(function() {

        $(window).resize(videoFullScreen);
        $(window).resize(resizeSvg);
        videoFullScreen();

    });
})

function resizeSvg() {
    var _mapW = $(".page.active .map").width();
    var _mapH = $(".page.active .map").height();

    console.log(_mapW);
    console.log(_mapH);


    $(".page.active svg").css({
        "height": _mapH + "px",
        "width": _mapW + "px"
    });
}

function videoFullScreen() {
    var winWidth = $(window).width();
    if (winWidth / jQuery('.introVideoLoop').outerHeight() > 16 / 9) {
        jQuery('.introVideoLoop video').css({
            'width': '100%',
            'height': 'auto',
        });
    } else {
        jQuery('.introVideoLoop video').css({
            'width': 'auto',
            'height': '100%',
        });
    }
    if (winWidth / jQuery('.sectionVideo.active').outerHeight() > 16 / 9) {
        jQuery('.sectionVideo.active video').css({
            'width': '100%',
            'height': 'auto',
        });
    } else {
        jQuery('.sectionVideo.active video').css({
            'width': 'auto',
            'height': '100%',
        });
    }
}

/* Replace IMG with SVG */
function replaceImgWithSVG() {
    if (jQuery('img.svg').length > 0) {
        jQuery("img.svg").each(function() {
            var jQueryimg = jQuery(this).eq(0);
            var jQueryparent = jQueryimg.parent();
            var imgID = jQueryimg.attr('id');
            var imgClass = jQueryimg.attr('class');
            var imgURL = jQueryimg.attr('src');

            jQuery.ajax({
                url: imgURL,
                dataType: 'html',
                type: 'GET',
                success: function(_data) {
                    // Replace image with new SVG
                    jQueryimg.replaceWith(_data);
                    // Get the SVG tag, ignore the rest
                    var jQuerysvg = jQueryparent.find('svg');
                    // Add replaced image's ID to the new SVG
                    if (typeof imgID !== 'undefined') {
                        jQuerysvg = jQuerysvg.attr('id', imgID);
                    }
                    // Add replaced image's classes to the new SVG
                    if (typeof imgClass !== 'undefined') {
                        jQuerysvg = jQuerysvg.attr('class', imgClass + ' svg');
                    }
                    // replaceImgWithSVG();
                }
            });
        });
    }
}

function navigation() {
    $(".more-info").on("click", toggleVision);
    $(".play-video").on("click", toggleVideo);
    $(".begin").on("click", begin);
    $(".bottom-nav a").on("click", onNavClick);
    $(".section-holder .pane a").on("click", onPaneClick);
    $(".top-nav .bookmark").on("click", toggleBookmark);
    $(".toggle-bookmarks").on("click", toggleBookmarks);
    $(".save-presentation").on("click", savePresentation);
    $(".openExternalLink").on("click", openExternalLink);

    function begin() {
        $(".left-nav, .right-nav, .begin").fadeOut(500);
        setTimeout(function() {
            $("body").removeClass('initial');
            $("body").addClass('intro');
        }, 500);
    }

    function toggleVideo() {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $("#landing .center, #landing .logos, .right-nav").fadeIn();
            $("#video").fadeOut();
            closeIntroVideo();
        } else {
            $(this).addClass('active');
            $("#landing .center, #landing .logos, .right-nav").fadeOut();
            $("#video").fadeIn();
            playIntroVideo();
        }
    }

    function playIntroVideo() {
        $(".introVideoLoop").addClass('active');
        var video = $(".introVideoLoop video");
        video.get(0).currentTime = 0;
        video[0].play();
        video[0].muted = false;
    }

    function closeIntroVideo() {
        $(".introVideoLoop").removeClass('active');
        var video = $(".introVideoLoop video");
        video.get(0).currentTime = 0;
        video[0].pause();
        video[0].muted = true;
    }

    function playSectionVideo() {
        $(".sectionVideo").addClass('active');
        var video = $(".sectionVideo video");
        video.get(0).currentTime = 0;
        video[0].play();
        video[0].muted = false;
    }

    function closeSectionVideo() {
        $(".sectionVideo").removeClass('active');
        var video = $(".sectionVideo video");
        video.get(0).currentTime = 0;
        video[0].pause();
        video[0].muted = true;
    }

    function toggleVision() {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $("body").removeClass('vision-active');
            setTimeout(function() {
                $("#vision").fadeOut(250);
                $("#landing .center, #landing .logos, .left-nav, #animation").fadeIn();
            }, 500);
        } else {
            $(this).addClass('active');
            $("#landing .center, #landing .logos, .left-nav, #animation").fadeOut(500);
            $("#vision").fadeIn();
            setTimeout(function() {
                $("body").addClass('vision-active');
            }, 500);
        }
    }

    function onNavClick() {
        var _section = $(this).attr("data-id");
        if (_section == "interactive-map") {
            return;
        }
        if (!$(this).hasClass('active')) {
            $("section").not('active').find(".section-holder .inner").css("left", "0px");
            $("section, .page").fadeOut(1000);
            $("section, .page, .bottom-nav a").removeClass('active');
            $("section[data-id='" + _section + "']").addClass('active').fadeIn(1000);
            $(".section-holder").fadeIn();
            $("section[data-id='" + _section + "']");
            $(this).addClass('active');
            if (_section == "landing") {
                closeSectionVideo();
                $("body").addClass('initial');
                $("body").removeClass('intro');
                setTimeout(function() {
                    $(".left-nav, .right-nav, .begin").fadeIn(500);
                }, 500);
            } else if (_section == "calculator") {
                $("body").removeClass('intro');
                refreshOverallCalculator();
            } else if (_section == "downtown") {
                $("body").removeClass('intro');
                playSectionVideo();
            } else {
                $("body").removeClass('intro');
                closeSectionVideo();
                // $(".section-holder .arrow-right").css("display", "block");
                // $(".section-holder .arrow-left").css("display", "none");
            }
        } else {
            $("section .page").fadeOut(1000).removeClass('active');
            $(".section-holder").fadeIn();
        }

        if (_section == "calculator") {
            $(".bookmark").css("display", "inline-block");
            checkBookmark();
        } else {
            $(".bookmark").css("display", "none");
        }

        return false;
    }

    function onPaneClick() {
        var _subSection = $(this).attr("data-id");
        var _section = $("section.active").attr("data-id");
        $("section.active .page").css("display", "none").removeClass('active');
        $("section.active .section-holder").fadeOut();
        $("section.active .page[data-id='" + _subSection + "']").fadeIn().addClass("active");
        $("section.active .page[data-id='" + _subSection + "'] > div").first().fadeIn();
        $("section.active .page[data-id='" + _subSection + "'] > div.suite .side-nav a[data-id='description']").click();
        $(".map-area").off("click", setActiveRow);
        $(".map-area").on("click", setActiveRow);

        $(".map-area").css("opacity", "1");
        $(".map-area").css("fill", "rgba(255,255,255,1)");
        $(".suite-links a:not(.on)").addClass('off');
        $(".pricing > div, .benefit > div").removeClass('active');
        resizeSvg();

        if (_section == "transformation" || _section == "suites" || _section == "paypal") {
            $(".bookmark").css("display", "inline-block");
            checkBookmark();
        } else {
            $(".bookmark").css("display", "none");
            checkBookmark();
        }

        return false;
    }

    $(".section-holder .arrow-left").css("display", "none");
    $(".section-holder .arrow-left").on("click", prevPane);
    $(".section-holder .arrow-right").on("click", nextPane);


    function prevPane() {
        traversePanes(-1);
    }

    function nextPane() {
        traversePanes(1);
    }

    function traversePanes(direction) {

        var _parent = $("section.active");

        if (direction == 1) {
            var _lastActive = _parent.find(".pane.active").last();
            _parent.find(".pane").addClass('animating');
            setTimeout(function() {
                _parent.find(".pane").removeClass('active');
                if (_lastActive.nextAll(".pane").eq(2).length > 0) {
                    _lastActive.nextAll(".pane").eq(2).addClass('active');
                    _lastActive.nextAll(".pane").eq(1).addClass('active');
                    _lastActive.nextAll(".pane").eq(0).addClass('active');
                } else if (_lastActive.nextAll(".pane").eq(1).length > 0) {
                    _lastActive.nextAll(".pane").eq(1).addClass('active');
                    _lastActive.nextAll(".pane").eq(0).addClass('active');
                    _lastActive.addClass('active');
                } else {
                    _lastActive.nextAll(".pane").eq(0).addClass('active');
                    _lastActive.addClass('active');
                    _lastActive.prev().addClass('active');
                }
                setTimeout(function() {
                    _parent.find(".pane").removeClass('animating');
                    checkArrows();
                }, 100);
            }, 600);
        } else {
            var _lastActive = _parent.find(".pane.active").first();
            _parent.find(".pane").addClass('animating');
            setTimeout(function() {
                _parent.find(".pane").removeClass('active');
                if (_lastActive.prevAll(".pane").eq(2).length > 0) {
                    _lastActive.prevAll(".pane").eq(2).addClass('active');
                    _lastActive.prevAll(".pane").eq(1).addClass('active');
                    _lastActive.prevAll(".pane").eq(0).addClass('active');
                } else if (_lastActive.prevAll(".pane").eq(1).length > 0) {
                    _lastActive.prevAll(".pane").eq(1).addClass('active');
                    _lastActive.prevAll(".pane").eq(0).addClass('active');
                    _lastActive.addClass('active');
                } else {
                    _lastActive.prevAll(".pane").eq(0).addClass('active');
                    _lastActive.addClass('active');
                    _lastActive.next().addClass('active');
                }
                setTimeout(function() {
                    _parent.find(".pane").removeClass('animating');
                    checkArrows();
                }, 100);
            }, 600);
        }
    }

    function checkArrows() {
        var _parent = $("section.active");

        var _lastActive = _parent.find(".pane.active").last();
        var _firstActive = _parent.find(".pane.active").first();
        if (_lastActive.next().length > 0) {
            _parent.find(".section-holder .arrow-right").css("display", "block");
        } else {
            _parent.find(".section-holder .arrow-right").css("display", "none");
        }
        if (_firstActive.prev().length > 0) {
            _parent.find(".section-holder .arrow-left").css("display", "block");
        } else {
            _parent.find(".section-holder .arrow-left").css("display", "none");
        }
    }
}


function beforeAfter() {
    $(".toggle-after").on("click", toggleAfter);

    function toggleAfter() {
        var _parent = $(this).parent();
        _parent.toggleClass('active');
        $(this).toggleClass('active');
        return false;
    }
}

function suites() {
    $(".suite-links a, div.suite .side-nav a").on("click", onSuiteNav);
    $(".pricing .priced > div").on("click", togglePricing);
    $(".cal-seats, .cal-term").on("change", calculate);
    $(".close-gal").on("click", closeGallery)
    $(".close-benefits").on("click", closeBenefits);
    $(".gallery .arrow-right").on("click", goNextGalImage);
    $(".gallery .arrow-left").on("click", goPrevGalImage);
    $(".gallery-indicators div").on("click", goToGalImage);
    $(".play-section-video").on("click", playGalleryVideo);
    $(".sectionVideo").on("click", pauseGalleryVideo);
    $("#calculator select").on("change", overallCalculate);
    $(".cal-full-location").on("change", toggleCalculatorPricing);

    function playGalleryVideo() {
        var video = $(".sectionVideo.active video");
        video[0].play();
        video[0].muted = false;
        $(".sectionVideo.active .play-section-video").fadeOut();
        return false;
    }

    function pauseGalleryVideo() {
        var video = $(".sectionVideo.active video");
        video[0].pause();
        $(".sectionVideo.active .play-section-video").fadeIn();
    }

    function stopGalleryVideo() {
        var video = $(".sectionVideo.active video");
        if (video.length > 0) {
            video.get(0).currentTime = 0;
            video[0].pause();
            video[0].muted = true;
            $(".sectionVideo .play-section-video").fadeIn();
        }
    }

    function onSuiteNav() {
        if (!$(this).hasClass('active')) {
            var _nav = $(this).attr("data-id");
            var _parent = $("section.active .page.active");
            _parent.find(".suite-links a").removeClass('active');
            if (_nav == "gallery") {
                viewGallery();
                videoFullScreen();
            } else if (_nav == "benefits-fold") {
                viewBenefits();
            } else {
                _parent.find(".content > div").removeClass('active');
                _parent.find(".side-nav a").removeClass('active');
                _parent.find("*[data-id='" + _nav + "']").addClass('active');
                refreshPricing();
            }
            checkBookmark();
        }
        return false;
    }


    function viewGallery() {
        var _parent = $("section.active .page.active");
        $("body").addClass('show-gallery');
        _parent.find(".suite").addClass('closed');
        _parent.find(".gallery-indicators div").first().click();
        return false;
    }

    function viewBenefits() {
        var _parent = $("section.active .page.active");
        $("body").addClass('show-benefits');
        _parent.find(".suite").addClass('closed');
        return false;
    }

    function togglePricing() {
        if (!$(this).hasClass('active')) {
            var _parent = $("section.active .page.active");
            _parent.find(".pricing > div > div").removeClass('active');
            $(this).addClass('active');
        }
    }

    function closeGallery() {
        var _parent = $("section.active .page.active");
        $("body").removeClass('show-gallery');
        _parent.find(".suite").removeClass('closed');
        _parent.find(".side-nav a[data-id='description']").click();
        console.log("yesh");
        stopGalleryVideo();
        return false;
    }

    function closeBenefits() {
        var _parent = $("section.active .page.active");
        $("body").removeClass('show-benefits');
        _parent.find(".suite").removeClass('closed');
        return false;
    }

    function goToGalImage() {
        var _galImg = $(this).attr("data-id");
        var _parent = $(this).parents().eq(1);
        stopGalleryVideo();
        if (!$(this).hasClass('active')) {
            _parent.find(".gallery-indicators div").removeClass('active');
            _parent.find(".inner > div").fadeOut().removeClass('active');
            $(this).addClass('active');
            _parent.find(".inner > div[data-id='" + _galImg + "']").fadeIn().addClass('active');
        }
        if (_parent.find(".inner > div[data-id='" + _galImg + "']").hasClass('sectionVideo')) {
            videoFullScreen();
        }
    }

    function goNextGalImage() {
        var _parent = $(this).parents().eq(1);
        if (_parent.find(".gallery-indicators div.active").next("div").length > 0) {
            _parent.find(".gallery-indicators div.active").next("div").click();
        } else {
            _parent.find(".gallery-indicators div").first().click();
        }
        return false;
    }

    function goPrevGalImage() {
        var _parent = $(this).parents().eq(1);
        if (_parent.find(".gallery-indicators div.active").prev("div").length > 0) {
            _parent.find(".gallery-indicators div.active").prev("div").click();
        } else {
            _parent.find(".gallery-indicators div").last().click();
        }
        return false;
    }
}

function setActiveRow() {
    var _section = $(this).attr("data-id");
    var _parent = $("section.active .page.active");
    $(".map-area").css("opacity", "0.5");
    if ($(this).hasClass('non-grouped')) {
        $(this).css("opacity", "1");
    } else {
        $(".map-area[data-id='" + _section + "']").css("opacity", "1");
    }

    _parent.find(".suite-links a").removeClass('off');
    _parent.find(".pricing > div").removeClass('active');
    _parent.find(".benefits > div").removeClass('active');
    _parent.find(".pricing > div[data-id='" + _section + "']").addClass('active');
    _parent.find(".benefits > div[data-id='" + _section + "']").addClass('active');
    refreshPricing();
    checkBookmark();
}

function calculate() {
    var _parent = $("section.active .page.active");
    var _seats = parseInt(_parent.find(".cal-seats").find(':selected').val());
    if (!_seats) {
        _seats = 1;
    }
    var _term = parseInt(_parent.find(".cal-term").find(':selected').val());
    var _full = parseInt(_parent.find(".priced.active .full strong").attr("data-id"));
    var _half = parseInt(_parent.find(".priced.active .half strong").attr("data-id"));
    var _pricingfull = _full * _seats / _term;
    var _pricinghalf = _half * _seats / _term;
    _parent.find(".priced.active .full strong").text("$" + ReplaceNumberWithCommas(_pricingfull.toFixed(2)));
    _parent.find(".priced.active .half strong").text("$" + ReplaceNumberWithCommas(_pricinghalf.toFixed(2)));
}

function overallCalculate() {
    var _parent = $("#calculator");
    var _seats = parseInt(_parent.find(".cal-full-seats").find(':selected').val());
    var _term = parseInt(_parent.find(".cal-full-term").find(':selected').val());
    var _term2 = parseInt(_parent.find(".cal-full-term-2").find(':selected').val());
    var _type = _parent.find(".cal-full-type").find(':selected').val();
    var _location = _parent.find(".price-points.active .cal-full-price-points").find(':selected').val();

    if (_location == "North End Tables") {
        $(".seats-div").css("display", "none");
        $(".tables-div").css("display", "inline-block");
        if (_type == "full") {
            var _price = parseInt(_parent.find(".cal-table-seats").find(':selected').attr("data-full"));
        } else if (_type == "half") {
            var _price = parseInt(_parent.find(".cal-table-seats").find(':selected').attr("data-half"));
        } else {
            var _price = 0;
        }
        _seats = 1;
    } else {
        $(".seats-div").css("display", "inline-block");
        $(".tables-div").css("display", "none");
        if (_type == "full") {
            var _price = parseInt(_parent.find(".price-points.active .cal-full-price-points").find(':selected').attr("data-full"));
        } else if (_type == "half") {
            var _price = parseInt(_parent.find(".price-points.active .cal-full-price-points").find(':selected').attr("data-half"));
        } else {
            var _price = 0;
        }
    }

    console.log(_seats);
    console.log(_price);
    console.log(_term);
    console.log(_type);

    var _pricing = (_price * _seats / _term);
    if (isNaN(_pricing) || !isFinite(_pricing)) {
        _pricing = 0;
    }
    var _pricing2 = (_price * _seats / _term2);
    if (isNaN(_pricing2) || !isFinite(_pricing2)) {
        _pricing2 = 0;
    }
    _parent.find(".full-total strong").text("$" + ReplaceNumberWithCommas(_pricing.toFixed(2)));
    _parent.find(".full-total-2 strong").text("$" + ReplaceNumberWithCommas(_pricing2.toFixed(2)));
}

function toggleCalculatorPricing() {
    var _location = $(this).find(':selected').val();
    console.log(_location);
    $(".price-points").removeClass("active");
    $(".price-points[data-id='" + _location + "']").addClass("active");
    $(".price-points[data-id='" + _location + "'] .cal-full-price-points")[0].selectedIndex = 0;
    $(".price-points[data-id='" + _location + "'] .cal-full-price-points").data("selectBox-selectBoxIt").refresh();
    overallCalculate();
}

function refreshOverallCalculator() {
    var _parent = $("#calculator");
    _parent.find(".cal-full-location")[0].selectedIndex = 0;
    _parent.find(".cal-full-seats")[0].selectedIndex = 0;
    _parent.find(".cal-full-price-points")[0].selectedIndex = 0;
    _parent.find(".cal-full-term")[0].selectedIndex = 0;
    _parent.find(".cal-full-term-2")[0].selectedIndex = 0;
    _parent.find(".cal-full-type")[0].selectedIndex = 0;

    _parent.find(".cal-full-location").data("selectBox-selectBoxIt").refresh();
    _parent.find(".cal-full-seats").data("selectBox-selectBoxIt").refresh();
    _parent.find(".cal-full-price-points").data("selectBox-selectBoxIt").refresh();
    _parent.find(".cal-full-term").data("selectBox-selectBoxIt").refresh();
    _parent.find(".cal-full-term-2").data("selectBox-selectBoxIt").refresh();
    _parent.find(".cal-full-type").data("selectBox-selectBoxIt").refresh();
    overallCalculate();
}

function refreshPricing() {
    var _parent = $("section.active .page.active");
    if (_parent.find(".cal-seats").length > 0) {
        _parent.find(".cal-seats")[0].selectedIndex = 0;
        _parent.find(".cal-term")[0].selectedIndex = 0;
        _parent.find('.cal-seats').data("selectBox-selectBoxIt").refresh();
        _parent.find('.cal-term').data("selectBox-selectBoxIt").refresh();
        calculate();
    }
}

function ReplaceNumberWithCommas(yourNumber) {
    //Seperates the components of the number
    var n = yourNumber.toString().split(".");
    //Comma-fies the first part
    n[0] = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    //Combines the two sections
    return n.join(".");
}


function openView() {
    var _section = $(this).attr("data-id")
    var _type = $(this).parent().attr("data-id");
    showPano(_type, _section);
}

function showPano(_type, _section) {
    $(".pano-ui a").removeClass('active');
    $(".pano-ui a").first().addClass('active');
    setTimeout(function() {
        $('body').addClass('show-virtual');
    }, 250);
    var _typeTextMapping = [];
    _typeTextMapping['sideline'] = "Sideline Suite ";
    _typeTextMapping['bunker'] = "Bunker Suite ";
    $('.in-virtual').text(_typeTextMapping[_type] + _section).attr("data-type", _type).attr("data-section", _section);
    $('.virtual-page-holder .view').html("<iframe id='virtual' src='panoramas/common/tour.html#" + _type + "/" + _section + "/ice/'></iframe>");
}

function panos() {
    $(".close-pano").on("click", closePano);
    $(".pano-ui a").on("click", togglePanoView);

    function togglePanoView() {
        if (!$(this).hasClass('active')) {
            var _type = $(".in-virtual").attr("data-type");
            var _section = $(".in-virtual").attr("data-section");
            var _view = $(this).attr("data-id");
            $('.virtual-page-holder .view').html("<iframe id='virtual' src='panoramas/common/tour.html#" + _type + "/" + _section + "/" + _view + "/'></iframe>");
            $(".pano-ui a").removeClass('active');
            $(this).addClass('active');
        }
        return false;
    }

    function closePano() {
        $('body').removeClass('show-virtual');
    }
}

jQuery.expr.filters.offscreen = function(el) {
    var rect = el.getBoundingClientRect();
    return (
        (rect.x + rect.width) < 0 ||
        (rect.y + rect.height) < 0 ||
        (rect.x > window.innerWidth || rect.y > window.innerHeight)
    );
};

function inViewport(element, strict, options = {}) {
    const rect = element.getBoundingClientRect();
    const height = window.innerHeight || document.documentElement.clientHeight;
    const width = window.innerWidth || document.documentElement.clientWidth;
    const offset = { left: 0, right: 0, top: 0, bottom: 0, ...options };

    // All 4 corners should be in viewport
    if (strict) {
        return (
            rect.top >= -offset.top &&
            rect.left >= -offset.left &&
            rect.bottom <= height + offset.bottom &&
            rect.right <= width + offset.right
        );
    }

    // At least 1 corner is in viewport
    return (
        rect.right >= -offset.left &&
        rect.bottom >= -offset.top &&
        rect.left <= width + offset.right &&
        rect.top <= height + offset.bottom
    );
}

/* Bookmarks */

function initBookmarks() {
    if (localStorage.bookmarks) {
        var _localBookmarks = JSON.parse(localStorage.bookmarks);
        console.log(_localBookmarks);
        if (_localBookmarks.length > 0) {
            var _r = confirm("If you are online and want to upload locally stored bookmarks click ok");
            if (_r) {
                try {
                    var _postParamsWhileOAppWasOffline = _localBookmarks.pop();
                    localStorage.bookmarks = JSON.stringify(_localBookmarks);
                    axios.post(submitUrl, _postParamsWhileOAppWasOffline)
                        .then(onPostFromOfflineBookmarks)
                        .catch(function(error) {
                            console.log(error);
                        });
                } catch (e) {
                    console.log(e)
                    _localBookmarks.push(_postParamsWhileOAppWasOffline);
                    localStorage.bookmarks = JSON.stringify(_localBookmarks);
                }
            }
        }
    } else {
        localStorage.bookmarks = "[]";
    }
}

function onPostFromOfflineBookmarks() {
    var _localBookmarks = JSON.parse(localStorage.bookmarks);
    if (_localBookmarks.length > 0) {
        var _postParamsWhileOAppWasOffline = _localBookmarks.pop();
        localStorage.bookmarks = JSON.stringify(_localBookmarks);
        axios.post(submitUrl, _postParamsWhileOAppWasOffline)
            .then(onPostFromOfflineBookmarks)
            .catch(function(error) {
                console.log(error);
            });
    }
}

function toggleBookmarks() {
    $("#bookmarks").fadeToggle();
    $("body").toggleClass('bookmarks-view');
    $(".remove-page").off("click", removeBookmark);
    $(".remove-page").on("click", removeBookmark);
    return false;
}


function toggleBookmark() {
    var _section = $("section.active").attr("data-id");
    if (_section == "transformation") {
        var _page = $(".page.active");
        var _pageName = _page.attr("data-name");
        var _bookmark = _page.attr("data-book");
        if (!_page.hasClass('bookmarked')) {
            _page.addClass('bookmarked');
            addBookmark(_bookmark, _pageName);
        }
    } else if (_section == "suites" || _section == "paypal") {
        var _page = $(".page.active");
        if ($("body").hasClass('show-gallery')) {
            if (_page.find(".priced.bookmarked").length == 0) {
                if (_page.find(".priced.active").length > 0) {
                    var _pageName = _page.attr("data-name") + ' - ' + _page.find(".priced.active").attr("data-name");
                    var _bookmark = _page.find(".priced.active").attr("data-book");
                    _page.find(".priced.active").addClass('bookmarked');
                } else {
                    var _pageName = _page.attr("data-name") + ' - ' + _page.find(".priced").first().attr("data-name");
                    var _bookmark = _page.find(".priced").first().attr("data-book");
                    _page.find(".priced").first().addClass('bookmarked');
                }
                addBookmark(_bookmark, _pageName);
            }
            var _pageName = _page.attr("data-name") + " - Gallery";
            var _bookmark = _page.find(".gallery").attr("data-book");
            if (!_page.find(".gallery").hasClass('bookmarked')) {
                _page.find(".gallery").addClass('bookmarked');
                addBookmark(_bookmark, _pageName);
            }
        } else if ($("body").hasClass('show-benefits')) {
            if (_page.find(".priced.bookmarked").length == 0) {
                if (_page.find(".priced.active").length > 0) {
                    var _pageName = _page.attr("data-name") + ' - ' + _page.find(".priced.active").attr("data-name");
                    var _bookmark = _page.find(".priced.active").attr("data-book");
                    _page.find(".priced.active").addClass('bookmarked');
                } else {
                    var _pageName = _page.attr("data-name") + ' - ' + _page.find(".priced").first().attr("data-name");
                    var _bookmark = _page.find(".priced").first().attr("data-book");
                    _page.find(".priced").first().addClass('bookmarked');
                }
                addBookmark(_bookmark, _pageName);
            }
            var _pageName = _page.attr("data-name") + " - Benefits";
            var _bookmark = _page.find(".chart").attr("data-book");
            if (!_page.find(".chart").hasClass('bookmarked')) {
                _page.find(".chart").addClass('bookmarked');
                addBookmark(_bookmark, _pageName);
            }
        } else if (_page.find(".benefits").hasClass('active')) {
            if (_page.find(".priced.bookmarked").length == 0) {
                if (_page.find(".priced.active").length > 0) {
                    var _pageName = _page.attr("data-name") + ' - ' + _page.find(".priced.active").attr("data-name");
                    var _bookmark = _page.find(".priced.active").attr("data-book");
                    _page.find(".priced.active").addClass('bookmarked');
                } else {
                    var _pageName = _page.attr("data-name") + ' - ' + _page.find(".priced").first().attr("data-name");
                    var _bookmark = _page.find(".priced").first().attr("data-book");
                    _page.find(".priced").first().addClass('bookmarked');
                }
                addBookmark(_bookmark, _pageName);
            }
            var _pageName = _page.attr("data-name") + " - Benefits";
            var _bookmark = _page.find(".benefits").attr("data-book");
            if (!_page.find(".benefits").hasClass('bookmarked')) {
                _page.find(".benefits").addClass('bookmarked');
                addBookmark(_bookmark, _pageName);
            }
        } else if (_page.find(".priced.active").length > 0) {
            var _pageName = _page.attr("data-name") + ' - ' + _page.find(".priced.active").attr("data-name");
            var _bookmark = _page.find(".priced.active").attr("data-book");
            if (!_page.find(".priced.active").hasClass('bookmarked')) {
                _page.find(".priced.active").addClass('bookmarked');
                addBookmark(_bookmark, _pageName);
            }
        } else {
            var _pageName = _page.attr("data-name") + ' - ' + _page.find(".priced").first().attr("data-name");
            var _bookmark = _page.find(".priced").first().attr("data-book");
            if (!_page.find(".priced").first().hasClass('bookmarked')) {
                _page.find(".priced").first().addClass('bookmarked');
                addBookmark(_bookmark, _pageName);
            }
        }
    } else if (_section == "calculator") {
        var _calculator = $("#calculator");
        var _location = _calculator.find(".price-points.active .cal-full-price-points").find(':selected').val();

        if (_location == "North End Tables") {
            var _pageName = _calculator.find(".price-points.active .cal-full-price-points").find(':selected').attr('data-name') + "/" + _calculator.find(".cal-full-type").find(':selected').attr("data-name") + "/" + _calculator.find(".cal-table-seats").find(':selected').attr("data-name") + " table/" + _calculator.find(".cal-full-term").find(':selected').attr("data-name") + "/" + _calculator.find(".cal-full-term-2").find(':selected').attr("data-name");
            var _bookmark = _calculator.find(".price-points.active .cal-full-price-points").find(':selected').attr('data-book') + "," + _calculator.find(".cal-full-type").find(':selected').attr("data-book") + "," + _calculator.find(".cal-table-seats").find(':selected').attr("data-book") + "," + _calculator.find(".cal-full-term").find(':selected').attr("data-book") + "," + _calculator.find(".cal-full-term-2").find(':selected').attr("data-book");
        } else {
            var _pageName = _calculator.find(".price-points.active .cal-full-price-points").find(':selected').attr('data-name') + "/" + _calculator.find(".cal-full-type").find(':selected').attr("data-name") + "/" + _calculator.find(".cal-full-seats").find(':selected').attr("data-name") + " seat(s)/" + _calculator.find(".cal-full-term").find(':selected').attr("data-name") + "/" + _calculator.find(".cal-full-term-2").find(':selected').attr("data-name");
            var _bookmark = _calculator.find(".price-points.active .cal-full-price-points").find(':selected').attr('data-book') + "," + _calculator.find(".cal-full-type").find(':selected').attr("data-book") + "," + _calculator.find(".cal-full-seats").find(':selected').attr("data-book") + "," + _calculator.find(".cal-full-term").find(':selected').attr("data-book") + "," + _calculator.find(".cal-full-term-2").find(':selected').attr("data-book");
        }
     
        var strIndex = _bookmark.indexOf('undefined');
        if (!$("#calculator").hasClass('bookmarked')) {
            if (strIndex == -1) {
                $("#calculator").addClass('bookmarked');
                addBookmark(_bookmark, _pageName);
            } else {
                alert("Please select all the dropdown options");
            }
        } else {
            alert("Please remove the current calculator entry from the bookmarks first");
        }
    } else {

    }
}

function addBookmark(_bookmark, _pageName) {
    var _sectionName = $("section.active").attr("data-name");
    $(".saved-pages").append("<div data-id='" + _bookmark + "' data-section='" + _sectionName + "'>" + _sectionName + ": " + _pageName + " <a href='#' class='remove-page'></a></div>");
    checkBookmark();
}

function removeBookmark() {
    var _bookmark = $(this).parent().attr("data-id");
    var _section = $(this).parent().attr("data-section");

    if (_section == "Calculator") {
        $("#calculator").removeClass('bookmarked');
    } else {
        $("*[data-book='" + _bookmark + "']").removeClass('bookmarked');
    }
    checkBookmark();
    $(this).parent().remove();
    return false;
}

function checkBookmark() {
    var _section = $("section.active").attr("data-id");
    var _element = $("html");
    if (_section == "transformation") {
        _element = $(".page.active");
    } else if (_section == "suites" || _section == "paypal") {
        var _page = $(".page.active");
        if ($("body").hasClass('show-gallery')) {
            _element = _page.find(".gallery");
        } else if ($("body").hasClass('show-benefits')) {
            _element = _page.find(".chart");
        } else if (_page.find(".benefits").hasClass('active')) {
            _element = _page.find(".benefits");
        } else if (_page.find(".priced.active").length > 0) {
            _element = _page.find(".priced.active");
        } else {
            _element = _page.find(".priced").first();
        }
    } else if (_section == "calculator") {
        _element = $("#calculator");
    } else {

    }

    console.log(_element);

    if (_element.hasClass('bookmarked')) {
        $("body").addClass('page-bookmarked');
    } else {
        $("body").removeClass('page-bookmarked');
    }

}

function savePresentation(e) {
    var _repId = $("#presenter").find(':selected').val();

    var _note = $("#your-note").val();

    var _postParams = {};

    $(".saved-pages > div").each(function(index) {
        //console.log( index + ": " + $( this ).text() );
        var _bookmark = $(this).attr("data-id");
        if (_bookmark.indexOf(",") !== -1) {
            var splitter = _bookmark.split(',');
            for (var _i = 0; _i < splitter.length; _i++) {
                _bookmarks.push(splitter[_i]);
            }
        } else {
            _bookmarks.push(_bookmark);
        }
    });

    var _bookmarksFiltered = _bookmarks.filter((a, b) => _bookmarks.indexOf(a) === b);

    _postParams.bookmarks = "";
    for (var _i = 0; _i < _bookmarksFiltered.length; _i++) {
        _postParams.bookmarks += _bookmarksFiltered[_i];
        if (_bookmarksFiltered.length - _i != 1) {
            _postParams.bookmarks += ",";
        }
    }

    var _errors = [];
    if (_repId == "") {
        _errors.push('Select a rep from the dropdown');
    }
    if (_note == "") {
        _errors.push('Enter a note');
    }

    if (_errors.length == 0) {
        _postParams.repId = _repId;
        _postParams.clientNote = _note;

        if (_postParams.repId == lastRepId && _postParams.clientNote == lastClientNote) {
            if (bookmarkId == "") {
                bookmarkId = getBookmarkId(_postParams.repId, _postParams.clientNote);
            }
            _postParams.bookmarkId = bookmarkId;
        } else {
            bookmarkId = getBookmarkId(_postParams.repId, _postParams.clientNote);
            _postParams.bookmarkId = bookmarkId;
        }

        lastRepId = _postParams.repId;
        lastClientNote = _postParams.clientNote;

        try {
            axios.post(submitUrl, _postParams)
                .then(onPostBookmarks)
                .catch(function(error) {
                    onErrorPostBookmarks(_postParams);
                })

        } catch (e) {
            //use $.post to submit bookmarks
            console.log(e);
            var _localBookmarks = []
            if (localStorage.bookmarks != "") {
                _localBookmarks = JSON.parse(localStorage.bookmarks);
            }
            _localBookmarks.push(_postParams);
            localStorage.bookmarks = JSON.stringify(_localBookmarks);
            alert("Your bookmarks have been saved, submit them when you are back online.");
        }
    } else {
        alert('Please review the following: ' + _errors.join(', '));
    }
    return false;
}

function onErrorPostBookmarks(_postParams) {
    var _localBookmarks = []
    if (localStorage.bookmarks != "") {
        _localBookmarks = JSON.parse(localStorage.bookmarks);
    }
    _localBookmarks.push(_postParams);
    localStorage.bookmarks = JSON.stringify(_localBookmarks);
    alert("Your bookmarks have been saved, submit them when you are back online.");
}

function onPostBookmarks(response) {
    //var r = JSON.parse(data);
    var r = response.data;
    BookmarkResponse(r.result);
    var _localBookmarks = JSON.parse(localStorage.bookmarks);
    if (_localBookmarks.length > 0) {
        var _postParamsWhileOAppWasOffline = localStorage.pop();
        localStorage.bookmarks = JSON.stringify(_localBookmarks);
        axios.post(submitUrl, _postParamsWhileOAppWasOffline)
            .then(onPostFromOfflineBookmarks)
            .catch(function(error) {
                console.log(error);
            });
    }
}

function BookmarkResponse(_type) {
    if (_type == "success") {
        alert('Your bookmarks have been submitted successfully.');
        clearBookmarks();
    } else if (_type == "offline") {
        alert('Your bookmarks have been saved locally for later submission.');
    } else if (_type == "uploaded") {
        alert('Your locally saved bookmarks have been uploaded.');
    }
}

function getBookmarkId(rid, cnote) {
    var d = new Date();
    var r = "" + d.getFullYear() + dig2(d.getMonth() + 1) + dig2(d.getDate()) + dig2(d.getHours()) + dig2(d.getMinutes()) + dig2(d.getSeconds());
    r += "-" + rid + "-" + escape(cnote.toLowerCase());
    if (r.length > 20) {
        r = r.substr(0, 20);
    }
    return r;
}

function clearBookmarks() {
    $("#presenter")[0].selectedIndex = 0;
    $("#presenter").data("selectBox-selectBoxIt").refresh();
    $("#your-note").val("");
    $(".saved-pages").html("");
    $("*").removeClass('bookmarked');
    checkBookmark();
}

function dig2(n) {
    if (n < 10) {
        return ("0" + n);
    } else {
        return ("" + n);
    }
}

//Electron 

var appMenuOpenTimeout = -1;
var _appNavButtons = [];
try {
    if (window.ipc != undefined) {
        _appNavButtons.push({ copy: "Check For New Content", icon: "restart.png", type: "update" });
        _appNavButtons.push({ copy: "Restart Presentation", icon: "restart.png", type: "restart" });
        _appNavButtons.push({ copy: "Toggle Full Screen", icon: "restart.png", type: "fullscreen" });
        console.log("success");
        showAppNav();
    }
} catch (e) {
    $(function() {
        $(document).ready(function() {
            window.showAppNav();
        });
    });
}

window.showAppNav = (_s) => {
    _appNavButtons.reverse();
    var _appNavButtonsHtml = [];
    for (var _i = 0; _i < _appNavButtons.length; _i++) {
        var _type = _appNavButtons[_i]["type"].split(':');
        var _subType = "";
        if (_type.length > 1) {
            _subType = "data-option='" + _type[1] + "'";
        }
        _appNavButtonsHtml.push("\
            <div class='app-nav-button' data-type='" + _type[0] + "' " + _subType + ">\
                <p class='text'>" + _appNavButtons[_i]["copy"] + "</p>\
            </div>\
        ");
    }
    $('body').append("\
        <div class='app-nav-holder'>\
            <div class='gear'><img src='assets/images/app-nav/gear.png' alt=''/><img class='notification' src='assets/images/app-nav/notification.png' alt=''/></div>\
            <div class='app-nav-buttons-holder'>" + _appNavButtonsHtml.join("") + "</div>\
        </div>\
    ");

    //add click events
    //$('.app-nav-button[data-type=bookmarks]').on("click", onClickShowBookmarks).addClass('disabled');    
    $('.app-nav-button[data-type=restart]').on("click", restartApp);
    $('.app-nav-button[data-type=update]').on("click", updateApp).append('<p class="updates">updates available</p>');
    $('.app-nav-button[data-type=fullscreen]').on("click", toggleFullscreen);
    $('.gear').on("click", showAppButtons);
    $('button').on('click', ambientCheckUpdate);

};
window.showFilesToUpdate = () => {
    $('.gear').addClass('show-notification');
    $('.app-nav-button[data-type=update]').addClass("show-updates").find('.text').text("Download Content Now");
}

function ambientCheckUpdate() {
    try {
        if (!$('.app-nav-button[data-type=update]').hasClass("show-updates")) {
            window.ipc.send('update-app', 1);
        }
    } catch (e) {}
}

function showAppButtons() {
    $('.app-nav-holder').toggleClass('show');
    if (appMenuOpenTimeout != -1) {
        clearTimeout(appMenuOpenTimeout);
    }
    appMenuOpenTimeout = setTimeout(hideAppButtons, 5000);
}

function hideAppButtons() {
    $('.app-nav-holder').removeClass('show');
}
window.updateApp = () => {
    if (appMenuOpenTimeout != -1) {
        clearTimeout(appMenuOpenTimeout);
    }
    $('.app-nav-holder').removeClass('show');
    try {
        window.ipc.send('update-app', 1);
    } catch (e) {}
}

function restartApp() {
    $('.app-nav-holder').removeClass('show');
    try {
        window.ipc.send('restart-app', 1);
    } catch (e) {}
}

function toggleFullscreen() {
    if (appMenuOpenTimeout != -1) {
        clearTimeout(appMenuOpenTimeout);
    }
    $('.app-nav-holder').removeClass('show');
    try {
        window.ipc.send('fullscreen-app', 1);
    } catch (e) {}
}

function openExternalLink(e) {
    e.preventDefault();
    window.shell.openExternal($(this).data('external'));
    return false;
}